import { CalendarState } from "@clockwise/web-commons/src/util/CalendarContext";

export const getCalendarDatesFromState = (calendarState: CalendarState) => {
  if (!calendarState) return null;
  return [calendarState.visibleDates.length === 1 ? "day" : "week", calendarState.focusedDate];
};
